import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as Cesium from 'cesium';
import { CoreService } from '../../../core/services/core.service';
import { DataContextService } from '../../../core/services/data-context.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-unit-attribute-visualizer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './unit-attribute-visualizer.component.html',
  styleUrl: './unit-attribute-visualizer.component.css'
})
export class UnitAttributeVisualizerComponent implements OnInit, OnDestroy {
  speed = 0;
  heading = 0;
  altitude = 0;
  temporalMetaData: Record<string, any> = {};

  private tickListenerName = 'unit-attribute-visualizer';
  private destroyed = false;
  mapEntity: any;
  mapEntityId:any

  constructor(
    private dataContext: DataContextService,
    private core: CoreService
  ) {}

  ngOnInit() {
    this.mapEntity = this.dataContext.getMapEntity(this.mapEntityId);
    this.core?.addOnTickListener(this.tickListenerName, this.onTick.bind(this));
  }

  ngOnDestroy() {
    this.destroyed = true;
    this.core?.removeOnTickListener(this.tickListenerName);
  }

  private onTick(clock: any) {
    if (!this.mapEntity || this.destroyed) return;

    let newDate = Cesium.JulianDate.addSeconds(clock.currentTime, -1, new Cesium.JulianDate());

    if (this.mapEntity.getSpeed) {
      const currentSpeed = this.mapEntity.getSpeedApp().getValue(newDate);
      const currentHeading = this.mapEntity.getHeadingApp().getValue(newDate);
      const currentPosition = this.mapEntity.getSampledPositions().getValue(newDate);

      if (currentSpeed !== undefined) {
        this.speed = Math.round(currentSpeed);
      }
      if (currentHeading !== undefined) {
        this.heading = Math.round(currentHeading);
      }
      if (currentPosition && currentPosition.z) {
        this.altitude = Math.round(Cesium.Cartographic.fromCartesian(currentPosition).height);
      }
    }

    this.temporalMetaData = {};
    if (this.mapEntity.getTemporalMetaData) {
      const meta = this.mapEntity.getTemporalMetaData();
      for (const key in meta) {
        this.temporalMetaData[key] = meta[key].getValue(newDate);
      }
    }
  }

  getMetaDataKeys(): string[] {
    return this.mapEntity?.getMetaData ? Object.keys(this.mapEntity.getMetaData()) : [];
  }

  getMetaDataValue(key: string): any {
    return this.mapEntity?.getMetaData ? this.mapEntity.getMetaData()[key] : '';
  }
}